<div class="l-master"
     *ngIf="authCredentials$ | async as authCredentials">
  <psei-top-bar
    *ngIf="apiVersions$ | async as ap"
    [projectTitle]="projectTitle"
    [envName]="ap.ppb.environment"
    [envCode]="ap.ppb.environmentCode"
    [showFullScreenWorkspace]="true"
    [showLogout]="true"
    [ngClass]="{
      'top-bar__env--dev': ap.ppb.environmentCode === 'DEV',
      'top-bar__env--devst': ap.ppb.environmentCode === 'DEVST',
      'top-bar__env--loc': ap.ppb.environmentCode === 'LOC'
    }"
    (logout)="logOut()">
    <ng-container controlsRight>
      <psei-button
        [tile]="true"
        [color]="'secondary'"
        [icon]="topbar.user.icon.name"
        [label]="authCredentials?.email || ''"
      ></psei-button>
      <ppb-lang-select></ppb-lang-select>
    </ng-container>
  </psei-top-bar>
  <div class="l-master__columns">
    <psei-side-menu class="l-master__menu"
                    [routeIsAllowed]="routeIsAllowed"
    ></psei-side-menu>
    <div class="l-master__content">
      <psei-breadcrumbs class="l-master__breadcrumbs"></psei-breadcrumbs>
      <div class="l-master__viewport" cdkScrollable>
        <router-outlet></router-outlet>
      </div>
      <div class="l-master__footer">
        <span>&copy; PSE</span>
        <span *ngIf="apiVersions$ | async as api"
              class="version-info">
                    v. {{appVersion}} (API v. {{api.ppb?.version}}-{{api.ppb?.tag}}, SDU-EXT v. {{api.sduExt?.version}}
          -{{api.sduExt?.tag}})
                </span>
      </div>
    </div>
  </div>
</div>
<ng-template #dialogTemplate>
  <div *ngIf="multipleSessions && multipleSessions.length >0">
    <h5>{{multipleSessionsHeader}}</h5>
    <table class="o-simple-table dialog-table">
      <thead>
      <tr>
        <th i18n="@@user.session_start_time">Początek sesji</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let session of multipleSessions">
        <td class="u-text-left">{{session.startDate | date:'yyyy-MM-dd HH:mm:ss'}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</ng-template>

